<ng-container *transloco="let t;">
<!-- Reject Modal -->
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t("Reject document modal title (Reject document modal) - Reject document")}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="rejectDocument" (ngSubmit)="onSubmit()">
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="reject-contract-container mt-50">
            <div class="row">
                <div class="col-xl-12 col-md-12 col-12">
                    <p class="mb-1 reject-info-text">{{t("Reject document confirm button text (Reject document modal) - Are you sure you want to reject this document")}}?</p>

                    <div class="reject-textarea">
                        <label for="basicTextarea">{{t("Reject document comment field text (Reject document modal) - Comments")}}</label>
                        <fieldset class="form-group">
                            <textarea [ngClass]="{'is-invalid error': (submitted && rejectDocument.get('reason')?.errors)}" formControlName="reason" class="form-control" id="basicTextarea" rows="4"></textarea>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" rippleEffect (click)="activeModal.close()"> {{t("Modal button (general) - No")}}</button>
        <button [disabled]="rejectDocumentLoader" type="submit" class="btn btn-danger" rippleEffect> {{t("Reject document button text (Reject document modal) - Reject")}} <span *ngIf="rejectDocumentLoader" class="spinner-border spinner-border-sm ms-50"></span></button>
    </div>
</form>
<!-- / Reject Modal -->
</ng-container>